import { ValidationProps, LoadOptions } from 'ui';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { CodeActionType, ReadOnlyConfiguration } from 'app/area/codetable/item/types';
import { FilterOption } from 'app/components/options-handler/types';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { CodetableMetadata } from 'app/area/codetable/types-store';

interface ScreenCommonProps {
  breadcrumbs?: number[];
  codeItem: CodeItem;
  readOnlyConfig?: ReadOnlyConfiguration;
  translation: CodetableTranslation;
}

export enum SupportedCodeScreens {
  ConsequencesSeverity = 277,
  ConsequencesRecurrence = 278,
  ConsequencesLikelihood = 279,
  ChecklistHierarchy = 266,
  CauseCategory = 104,
  InteractionOption = 444,
  Company = 37,
  Reference = 38,
  RecurrenceFrequency = 130,
  Severity = 134,
  Likelihood = 169,
  IntegrityStatus = 393,
  Evaluation = 260,
  SubstanceHierarchy = 341,
  SubstanceCategory = 351,
  UnitOfMeasureSet = 398,
  UnitOfMeasureConversionType = 397,
  InsuranceType = 122,
  SecurityBreachType = 243,
  UnitOfMeasure = 338,
  RiskArea = 131,
  GasType = 496
}

export enum ScreenPicker {
  likelihood = 'likelihood',
  recurrence = 'recurrence',
  severity = 'severity',
  defaultUom = 'defaultUom',
  defaultUomType = 'defaultUomType',
  substanceUomSet = 'substanceUomSet',
  substanceConversionFactor = 'substanceConversionFactor',

  uomSetValueType = 'uomType',
  uom = 'uom',
  uomSetIndicatorValueType = 'uomTypeIndicator',
  uomSetIndicatorValue = 'uomIndicator',

  checkedCode = 'checkedCode',
  uncheckedCode = 'uncheckedCode',
  referenceCodeCategory = 'referenceCodeCategory',
  category = 'category',

  uomFrom = 'uomFrom',
  uomTo = 'uomTo',
  uomTypeTo = 'uomTypeTo',
  uomTypeFrom = 'uomTypeFrom',
  uomConversion = 'uomConversion',
  uomConversionType = 'uomConversionType',
  consequenceType = 'consequenceType',
  measurementSystem = 'measurementSystem',
  unitOfMeasure = 'unitOfMeasure',
  residualIcon = 'residualIcon',
  sequence = 'sequence',
  companyRegisterId = 'companyRegisterId',
  gasType = 'gasType',
  safetyLimit = 'safetyLimit',
  application = 'application',
  minValue = 'minValue',
  maxValue = 'maxValue',
  warningDeviationPercent = 'warningDeviationPercent'
}

export enum ScreenField {
  low = 'low',
  mid = 'mid',
  high = 'high',
  scoreCalcWeight = 'scoreCalcWeight',
  companyRegisterId = 'companyRegisterId',
  minLevel = 'minLevel',
  recurrenceLevel = 'level',
  severityLevel = 'level',
  likelihoodLevel = 'level',
  rangeFrom = 'rangeFrom',
  rangeTo = 'rangeTo',
  factor = 'factor',
  warningDeviationPercent = 'warningDeviationPercent'
}

export interface ScreenPickerProps extends ScreenCommonProps {
  updateByKey: <T>(key: string, value: T) => void;
  clearByKey: (key: string) => void;
  updateValidation: (validation: { [key: string]: ValidationProps }) => void;
  resetValidation: (key: string) => void;
  codetableOptions: {
    [key: string]: {
      fetching: boolean;
      codes: CodeComplexValue<number>[];
    };
  };
  options?: {
    [key: string]: FilterOption;
  };
  required?: boolean;
  validation?: { [key: string]: ValidationProps };
  actionType?: CodeActionType;
  loadCodetableOptions: (
    id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions) => void;
  loadOptions?: (
    id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
}

export interface ScreenFieldProps extends ScreenCommonProps {
  updateByKey: <T>(key: ScreenPicker | ScreenField, value: T) => void;
  resetValidation: (key: string) => void;
  required?: boolean;
  validation?: { [key: string]: ValidationProps };
  metadata?: CodetableMetadata;
}
